module.exports = __webpack_public_path__ + "static/media/level-3-blue.a1ffa004.svg";